// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.privacy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 24px 80px;
}

.privacy-header {
  text-align: center;
  margin-bottom: 48px;
}

.privacy-header h1 {
  font-size: 36px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 16px;
}

.privacy-header .subtitle {
  font-size: 16px;
  color: #718096;
}

.privacy-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 48px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.privacy-intro {
  font-size: 17px;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid #e2e8f0;
}

.privacy-section {
  margin-bottom: 36px;
}

.privacy-section:last-child {
  margin-bottom: 0;
}

.privacy-section h2 {
  font-size: 22px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.privacy-section h2::before {
  content: '';
  width: 4px;
  height: 24px;
  background: #2d3748;
  border-radius: 2px;
}

.privacy-section p {
  font-size: 16px;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 16px;
}

.privacy-section p:last-child {
  margin-bottom: 0;
}

.privacy-list {
  list-style: none;
  padding: 0;
  margin: 16px 0 0 0;
}

.privacy-list li {
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 1.7;
  color: #4a5568;
}

.privacy-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #48bb78;
  font-weight: 600;
}

.privacy-list.warning-list li::before {
  content: '✕';
  color: #e53e3e;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #2d3748;
  text-decoration: none;
  font-weight: 500;
  margin-top: 32px;
  transition: all 0.2s;
}

.back-link:hover {
  gap: 12px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .privacy-container {
    padding: 40px 16px 60px;
  }

  .privacy-header {
    margin-bottom: 32px;
  }

  .privacy-header h1 {
    font-size: 28px;
  }

  .privacy-content {
    padding: 28px 20px;
    border-radius: 12px;
  }

  .privacy-intro {
    font-size: 15px;
    margin-bottom: 28px;
    padding-bottom: 24px;
  }

  .privacy-section {
    margin-bottom: 28px;
  }

  .privacy-section h2 {
    font-size: 18px;
  }

  .privacy-section h2::before {
    height: 20px;
  }

  .privacy-section p,
  .privacy-list li {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .privacy-header h1 {
    font-size: 24px;
  }

  .privacy-content {
    padding: 24px 16px;
  }

  .privacy-section h2 {
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".privacy-page {\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n.privacy-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 60px 24px 80px;\n}\n\n.privacy-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.privacy-header h1 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 16px;\n}\n\n.privacy-header .subtitle {\n  font-size: 16px;\n  color: #718096;\n}\n\n.privacy-content {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 48px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n}\n\n.privacy-intro {\n  font-size: 17px;\n  line-height: 1.8;\n  color: #4a5568;\n  margin-bottom: 40px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.privacy-section {\n  margin-bottom: 36px;\n}\n\n.privacy-section:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-section h2 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.privacy-section h2::before {\n  content: '';\n  width: 4px;\n  height: 24px;\n  background: #2d3748;\n  border-radius: 2px;\n}\n\n.privacy-section p {\n  font-size: 16px;\n  line-height: 1.8;\n  color: #4a5568;\n  margin-bottom: 16px;\n}\n\n.privacy-section p:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-list {\n  list-style: none;\n  padding: 0;\n  margin: 16px 0 0 0;\n}\n\n.privacy-list li {\n  position: relative;\n  padding-left: 28px;\n  margin-bottom: 12px;\n  font-size: 16px;\n  line-height: 1.7;\n  color: #4a5568;\n}\n\n.privacy-list li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: #48bb78;\n  font-weight: 600;\n}\n\n.privacy-list.warning-list li::before {\n  content: '✕';\n  color: #e53e3e;\n}\n\n.back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #2d3748;\n  text-decoration: none;\n  font-weight: 500;\n  margin-top: 32px;\n  transition: all 0.2s;\n}\n\n.back-link:hover {\n  gap: 12px;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .privacy-container {\n    padding: 40px 16px 60px;\n  }\n\n  .privacy-header {\n    margin-bottom: 32px;\n  }\n\n  .privacy-header h1 {\n    font-size: 28px;\n  }\n\n  .privacy-content {\n    padding: 28px 20px;\n    border-radius: 12px;\n  }\n\n  .privacy-intro {\n    font-size: 15px;\n    margin-bottom: 28px;\n    padding-bottom: 24px;\n  }\n\n  .privacy-section {\n    margin-bottom: 28px;\n  }\n\n  .privacy-section h2 {\n    font-size: 18px;\n  }\n\n  .privacy-section h2::before {\n    height: 20px;\n  }\n\n  .privacy-section p,\n  .privacy-list li {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .privacy-header h1 {\n    font-size: 24px;\n  }\n\n  .privacy-content {\n    padding: 24px 16px;\n  }\n\n  .privacy-section h2 {\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
